<template>
  <div class="container-fluid" :class="{ 'box-container': !showInListMode }">
    <div
      v-if="!isReadOnly"
      class="row"
      :class="{ 'box-container': showInListMode }"
    >
      <div class="col">
        <ValidationObserver ref="searchStudentRef">
          <div class="row p-3">
            <div
              class="col-12"
              :class="[hasSearched ? 'col-md-5 border-divider' : 'col-md-6']"
            >
              <div class="mb-4">
                <em
                  class="fas fa-user-plus rounded-circle shadow text-orange p-2 mr-2"
                />
                <span class="box-title">Buscar Estudiante</span>
              </div>
              <div>
                <ValidationProvider v-slot="{ errors }" rules="required">
                  <custom-input
                    v-model="value.studentSIE"
                    placeholder="Escriba Número de SIE"
                    :error="errors[0]"
                    custom-error-msg="Favor escriba número de SIE."
                  />
                </ValidationProvider>
              </div>
            </div>
            <div
              v-if="hasSearched"
              class="col-12 col-md ml-0 ml-md-3 mt-4 mt-md-0 mb-4 mb-md-0"
            >
              <custom-balloon class="w-40 mb-2" :text="'Resultado'" />
              <div v-if="student">
                <div>
                  <span class="box-result-field-label mr-1">Nombre:</span>
                  <span class="box-result-field-value">{{ student.name }}</span>
                </div>
                <div>
                  <span class="box-result-field-label mr-1">Edad:</span>
                  <span class="box-result-field-value">{{ student.age }}</span>
                </div>
                <div>
                  <span class="box-result-field-label mr-1">SIE:</span>
                  <span class="box-result-field-value">
                    {{ student.studentSie }}
                  </span>
                </div>
                <div>
                  <span class="box-result-field-label mr-1">Registro:</span>
                  <span class="box-result-field-value">
                    {{ student.regNumber }}
                  </span>
                </div>
                <div>
                  <span class="box-result-field-label mr-1">Estatus:</span>
                  <span class="box-result-field-value">
                    {{ student.status }}
                  </span>
                </div>
              </div>
              <div v-else class="box-result-empty">
                No se encontró Número de SIE en el sistema
              </div>
            </div>
            <div
              v-if="hasSearched && student"
              class="col-12 col-md d-flex justify-content-center justify-content-md-end align-items-end"
            >
              <ActionButton
                id="action-btn"
                class="mr-3"
                variant="outline-danger"
                i="fas fa-times-circle"
                text="Cancelar"
                @click="hasSearched = false"
              />
              <ActionButton
                id="action-btn"
                :disabled="isDisabled"
                text="Añadir"
                variant="success"
                i="fas fa-file-plus"
                @click="addStudent()"
              />
            </div>
            <div
              v-else
              class="col-12 col-md d-flex justify-content-end align-items-end"
            >
              <ActionButton
                class="full-width-btn"
                text="Buscar"
                variant="success"
                i="fa fa-search"
                @click="searchStudent()"
              />
            </div>
          </div>
        </ValidationObserver>
      </div>
    </div>
    <div
      v-if="showList"
      class="row pt-3 pb-3"
      :class="{ 'box-divider': !showInListMode }"
    >
      <div class="col box-divider-group" />
      <div class="col-auto pl-1 pr-1">
        <custom-balloon
          class="pl-2 pr-2"
          :text="'Estudiantes Seleccionados'"
          :class="{ 'dark-gray-bg': showInListMode }"
        />
      </div>
      <div class="col box-divider-group" />
    </div>
    <template v-if="showList">
      <template v-if="showInListMode">
        <div class="row">
          <div class="col p-0">
            <custom-callout
              v-for="currentStudent in this.value.studentList"
              :key="currentStudent.id"
              :has-toggle="true"
              :opened="isCalloutExpanded"
              class="mt-2 mb-3"
            >
              <div class="row mt-2">
                <div
                  v-if="currentStudent.provRemReqNumber"
                  class="col-md-2 col-lg-2 d-flex align-items-center justify-content-center"
                  :class="{
                    'divider-horizontal': !isMobile,
                    'divider-vertical': isMobile
                  }"
                >
                  <div
                    class="row"
                    :class="{ 'pr-3 float-left': isMobile }"
                  >
                    <div>
                      <custom-balloon
                        class="px-3"
                        :text="currentStudent.provRemReqNumber"
                        background-color="green-light"
                      />
                    </div>
                  </div>
                </div>
                <div :class="['pt3', currentStudent.provRemReqNumber ? 'col-md-8 col-lg-8' : 'col-md-10 col-lg-10']">
                  <div class="row">
                    <div class="col-12 col-md-4 mb-2">
                      <span class="box-result-field-label">Estudiante:</span>
                      <br />
                      <span class="box-result-field-value">
                        {{ formatStudentName(currentStudent) }}
                      </span>
                    </div>
                    <div class="col-12 col-md-4 mb-2">
                      <span class="box-result-field-label">PEI:</span>
                      <br />
                      <span class="box-result-field-value">
                        {{ formatPei(currentStudent.lastSignedPei) }}
                      </span>
                    </div>
                    <div class="col-12 col-md-4 mb-2">
                      <span class="box-result-field-label">Grado:</span>
                      <br />
                      <span class="box-result-field-value">
                        {{ currentStudent.grade }}
                      </span>
                    </div>
                    <div class="col-12 col-md-4 mb-2">
                      <span class="box-result-field-label">Impedimento:</span>
                      <br />
                      <span class="box-result-field-value">
                        {{ currentStudent.impediment }}
                      </span>
                    </div>
                    <div class="col-12 col-md-4 mb-2">
                      <span class="box-result-field-label">Estatus:</span>
                      <br />
                      <span class="box-result-field-value">
                        {{ currentStudent.status }}
                      </span>
                    </div>
                    <div class="col-12 col-md-4 mb-2">
                      <span class="box-result-field-label">
                        Alternativa Ubicación:
                      </span>
                      <br />
                      <span class="box-result-field-value">
                        {{ currentStudent.ubicationAlternative }}
                      </span>
                    </div>
                  </div>
                </div>
                <div class="col-md-2 d-flex align-items-center justify-content-md-end">
                  <div class="custom-button pr-md-4" :class="{'w-100': isMobile}">
                    <DropDown
                      :items="getStudentActions(currentStudent)"
                      class="w-100 d-sm-block custom-ac-btn"
                    />
                  </div>
                </div>
              </div>
              <template #edition>
                <div
                  v-if="studentHasNecessities(currentStudent.studentSie)"
                  class="container-fluid callout-expanded-container mt-2"
                >
                  <div
                    v-for="(studentNecessity,
                    index) in getStudentNecessitiesFromStudent(
                      currentStudent.studentSie
                    )"
                    :key="index"
                    class="row callout-expanded-item py-2"
                  >
                    <div class="col">
                      <span class="box-result-field-label">Servicios:</span>
                      <br />
                      <span class="box-result-field-value">
                        {{ studentNecessity.necessityName }}
                      </span>
                    </div>
                    <div
                      v-for="(document, idx) in studentNecessity.documents"
                      :key="idx"
                      :class="[document.file || document.itemAttachmentId ? 'col' : 'd-none']"
                    >
                      <span class="box-result-field-label">
                        {{ document.documentTypeName }}:
                      </span>
                      <br />
                      <div
                        v-if="document.file || document.itemAttachmentId"
                        class="d-flex align-items-center w-100 justify-content-start"
                      >
                        <div class="font-weight-normal">
                          <label class="circle-green" />
                          <label class="mb-0">
                            {{
                              document.file
                                ? document.file.name
                                : document.filename
                            }}
                          </label>
                        </div>
                        <div
                          v-if="
                            document.file
                              ? document.file.name
                              : document.filename
                          "
                          class="d-flex flex-row-reverse ml-2 button-container"
                        >
                          <button
                            type="button"
                            class="btn outline-success mr-2 ml-2"
                            @click="downloadFile(document)"
                          >
                            <i class="fas fa-file-download" />
                          </button>
                        </div>
                      </div>
                    </div>
                    <div
                      v-for="assistantType in studentNecessity.assistantTypes"
                      :key="assistantType.id"
                      class="col"
                    >
                      <span class="box-result-field-label">
                        Tipo de Asistencia de Salud:
                      </span>
                      <br />
                      <span class="box-result-field-value">
                        {{ assistantType.name }}
                      </span>
                    </div>
                  </div>
                </div>
              </template>
            </custom-callout>
          </div>
        </div>
      </template>
      <template v-else>
        <div
          v-for="currentStudent in this.value.studentList"
          :key="currentStudent.id"
          class="row pt-3 pb-3"
          :class="{ 'box-item-border-bottom': showBoxItemBorderBottom }"
        >
          <div class="col-12 col-md-2 mb-4 mb-md-0">
            <span class="box-result-field-label mr-1">Estudiante:</span>
            <br />
            <span class="box-result-field-value">
              {{ formatStudentName(currentStudent) }}
            </span>
          </div>
          <div class="col-6 col-md">
            <span class="box-result-field-label">PEI:</span>
            <br />
            <span class="box-result-field-value">
              {{ formatPei(currentStudent.lastSignedPei) }}
            </span>
          </div>
          <div class="col-6 col-md">
            <span class="box-result-field-label mr-1">Grado:</span>
            <br />
            <span class="box-result-field-value">
              {{ currentStudent.grade }}
            </span>
          </div>
          <div class="col-6 col-md mt-4 mt-md-0 mb-4 mb-md-0">
            <span class="box-result-field-label mr-1">Impedimento:</span>
            <br />
            <span class="box-result-field-value">
              {{ currentStudent.impediment }}
            </span>
          </div>
          <div class="col-12 col-md mb-2 mb-md-0">
            <span class="box-result-field-label">Estatus:</span>
            <br />
            <span class="box-result-field-value">
              {{ currentStudent.status }}
            </span>
          </div>
          <div class="col-6 col-md mt-4 mt-md-0 mb-4 mb-md-0">
            <span class="box-result-field-label mr-1">
              Alternativa Ubicación:
            </span>
            <br />
            <span class="box-result-field-value">
              {{ currentStudent.ubicationAlternative }}
            </span>
          </div>
          <div
            class="col-12 col-md-2 d-flex align-items-center justify-content-end"
          >
            <ActionButton
              v-if="!isReadOnly"
              class="delete-btn full-width-btn"
              variant="outline-danger"
              i="fas fa-times-circle"
              text="Eliminar"
              @click="deleteStudent(currentStudent)"
            />
          </div>
        </div>
      </template>
    </template>
  </div>
</template>

<script>
import _ from "lodash";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import CustomInput from "CustomInput";
import ActionButton from "ActionButton";
import DropDown from "dropdown";
import CustomBalloon from "custom-balloon";
import CustomCallout from "custom-callout";
import alert from "@/mixin/alert.mixin";
import generalService from "@/services/pei/general";
import documentsService from "@/services/documents";
import { requestTypeCodes } from "@/utils/constants/hrrequest/requestTypeCodes";
import StudentStatuses from "@/utils/constants/student/studentStatuses";
import { getDeterminationLetterReport as _getDeterminationLetterReport } from "@/modules/human-resources/api";

export default {
  name: "Tab2StudentManagement",
  mixins: [alert],
  components: {
    ValidationProvider,
    ValidationObserver,
    CustomInput,
    ActionButton,
    DropDown,
    CustomBalloon,
    CustomCallout
  },
  props: {
    value: {
      type: Object,
      required: true
    },
    isReadOnly: {
      type: Boolean,
      default: false
    },
    showInListMode: {
      type: Boolean,
      default: false
    },
    showProvRemReqAction: {
      type: Boolean,
      default: false
    },
    collections: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      hasSearched: false,
      isCalloutExpanded: false
    };
  },
  methods: {
    async searchStudent() {
      const isValid = await this.$refs.searchStudentRef.validate();
      if (isValid) {
        this.$emit("click", "onSearchStudent");
        this.hasSearched = true;
      }
    },
    async deleteStudent(student) {
      const hasNecessities = this.studentHasNecessities(student.studentSie);
      const message = hasNecessities
        ? `El estudiante cuenta con información documentada en la solicitud,
          ¿está seguro que desea eliminar la información del estudiante
          <b>${this.formatStudentName(student)}</b> de la solicitud?`
        : `¿Está seguro que desea eliminar el estudiante <b>${this.formatStudentName(
            student
          )}</b> de la solicitud?`;

      const response = await this.ShowCancelModal("Confirmación", message);
      if (!response) return;

      if (hasNecessities) this.removeStudentDocumentedInfo(student.studentSie);
      this.removeStudentFromCollection(student.studentSie);
      this.value.studentList = this.value.studentList.filter(
        currentStudent => currentStudent.studentSie !== student.studentSie
      );
      this.$emit("onRemoveStudent", student);
      this.ShowToast(
        "Confirmación",
        "El estudiante ha sido removido de la solicitud exitosamente. Debe oprimir guardar para que persistan los cambios.",
        "success"
      );
    },
    removeStudentDocumentedInfo(studentSie) {
      this.value.necessities.forEach(neccesity => {
        neccesity.studentNecessities.forEach((studentNecessity, index) => {
          if (studentNecessity.studentSieId == studentSie)
            neccesity.studentNecessities.splice(index, 1);
        });
      });

      this.collections.necessities.forEach(necessity => {
        if (
          necessity.selected &&
          !this.necessityHasStudents(studentSie, necessity.id)
        ) {
          this.$emit("onRemoveNecessity", necessity);
          this.value.necessities = this.value.necessities.filter(
            n => n.necessityId !== necessity.id
          );
        }
      });
    },
    removeStudentFromCollection(studentSie) {
      for (const key in this.collections)
        if (
          this.collections.hasOwnProperty(key) &&
          this.collections[key].id &&
          key.endsWith("Student")
        ) {
          this.collections[key].list = this.collections[key].list.filter(
            student => student.studentSie !== studentSie
          );
        }
    },
    validateAddStudent() {
      const studentLength = this.value.studentList.length;
      if (
        this.value.assistantTypeId == requestTypeCodes.Estudiantes &&
        this.value.studentList.length === 1
      ) {
        return false;
      }
      if (
        this.value.assistantTypeId == requestTypeCodes.DosMasEstudiantes &&
        !_.inRange(studentLength, 0, this.value.requestPersonalTwoOrMoreMax)
      ) {
        return false;
      }
      if (
        this.value.assistantTypeId == requestTypeCodes.Grupo &&
        !_.inRange(studentLength, 0, this.value.requestPersonalGroupMax)
      ) {
        return false;
      }
      return true;
    },
    addStudent() {
      const isValid = this.validateAddStudent();
      if (!isValid) {
        this.ShowToast(
          "Alerta",
          "Para añadir otro estudiante debe eliminar el estudiante seleccionado.",
          "error"
        );
        return;
      }

      const found = this.value.studentList.find(
        student => student.studentSie === this.value.student.studentSie
      );

      if (found) {
        this.ShowToast(
          "Alerta",
          "El estudiante se encuentra añadido en la lista de estudiantes seleccionados.",
          "error"
        );
        return;
      }

      const isAnotherLocationSchool = this.value.studentList.some(
        student =>
          student.locationSchoolId !== this.value.student.locationSchoolId
      );

      if (isAnotherLocationSchool) {
        this.ShowToast(
          "Alerta",
          this.collections.resources["R01210001"],
          "error"
        );
        return;
      }

      const allowedStudentStatuses = [
        StudentStatuses.Elegible,
        StudentStatuses.Servido
      ];
      if (!allowedStudentStatuses.includes(this.value.student.statusId)) {
        this.ShowToast(
          "Alerta",
          this.collections.resources["R01210004"],
          "error"
        );
        return;
      }

      this.value.studentList.push(this.value.student);
      this.hasSearched = false;
      this.value.studentSIE = "";
      this.$refs.searchStudentRef.reset();
      this.addStudentToCollections();
    },
    addStudentToCollections() {
      const serviceNeedCategoryIds = [
        ...new Set(
          this.value.student.serviceNeeds.map(s => s.serviceNeedCategoryId)
        )
      ];
      serviceNeedCategoryIds.forEach(serviceNeedCategoryId => {
        for (const key in this.collections)
          if (
            this.collections.hasOwnProperty(key) &&
            this.collections[key].id === serviceNeedCategoryId
          ) {
            this.collections[key].list.push(this.value.student);
            break;
          }
      });
    },
    studentHasNecessities(studentSie) {
      return this.value.necessities.some(necessity =>
        necessity.studentNecessities.some(e => e.studentSieId === studentSie)
      );
    },
    necessityHasStudents(studentSie, serviceNeedCategoryId) {
      return this.value.studentList.some(
        student =>
          student.studentSie !== studentSie &&
          student.serviceNeeds.some(
            sn => sn.serviceNeedCategoryId == serviceNeedCategoryId
          )
      );
    },
    getStudentNecessitiesFromStudent(studentSie) {
      const studentNecessities = [];
      this.value.necessities.forEach(necessity => {
        let studentNecessity = necessity.studentNecessities.find(
          e => e.studentSieId === studentSie
        );
        if (studentNecessity) {
          studentNecessity.necessityName = necessity.name;
          studentNecessities.push(studentNecessity);
        }
      });
      return studentNecessities;
    },
    formatStudentName(student) {
      return student.studentSie + " - " + student.name;
    },
    formatPei(peiId) {
      if (peiId) {
        const year = peiId.slice(0, 4);
        const id = peiId.slice(4);

        return `${year}-${id}`;
      }

      return "-";
    },
    downloadFile(document) {
      if (document.itemAttachmentId)
        return documentsService.downloadFromServer(document.itemAttachmentId);
      else
        return documentsService.downloadFile({
          content: document.file,
          filename: document.file.name
        });
    },
    getReportsPEIPS(student) {
      let peiId = student.lastSignedPei;
      let self = this;

      let promise = new Promise(resolve => {
        self
          .$ApiGet("/api/report/pei/" + peiId)
          .then(res => {
            self.report = res.data;
            generalService.documentDownloadReport(
              self.report.content,
              self.report.filename
            );
            resolve(res.data);
          })
          .catch(err => {
            self.response = err;
          });
      });
      return promise;
    },
    async downloadRpRequest(student){
      await generalService.downloadMipeReport(
        `rprequest/${student.provRemReqNumber}`
      );         
    },
    async downloadDeterminationLetter(student) {     
      await _getDeterminationLetterReport({
        requestServiceId: student.provRemRequestService.requestServiceId,
          serviceTypeId: student.provRemRequestService.serviceTypeId,
          serviceStatusId: student.provRemRequestService.serviceStatusId,
          determinationReasonId: student.provRemRequestService.determinationReasonId,
          determinationReasonCategoryId: student.provRemRequestService.determinationReasonCategoryId,
      })
        .then((res) => generalService.ConvertToBlob(res.data))
        .catch((err) => {          
          this.ShowToast('', err.response?.data?.message, 'error');
        });      
    },
  }, 
  computed: {
    isMobile() {
      return this.$store.getters.getIsMobileDensity;
    },
    getStudentActions() {
      const self = this;
      return student => {
        const actions = [];
        if (student.lastSignedPei) {
          actions.unshift({
            label: "Descargar Reporte del PEI o PS",
            icon: "fas fa-file-download text-green pr-1",
            click: () => this.getReportsPEIPS(student)
          });
        }
        if (student.provRemReqId) {
          actions.unshift({
            label: "Descargar Solicitud",
            icon: "fas fa-print color-primary-1",
            click: () => this.downloadRpRequest(student)
          });
          actions.unshift({
            label: "Descargar Carta de Aprobación",
            icon: "fas fa-print color-primary-1",
            click: () => this.downloadDeterminationLetter(student)
          });          
        }
        if (this.showProvRemReqAction && !student.provRemReqId) {
          actions.unshift({
            label: "Crear Solicitud de Remedio Provisional",
            icon: "fas fa-plus-circle text-green pr-1",
            click: () => this.$emit("onCreateProvRemReq", student.studentSie)
          });
        }
        if (!self.isReadOnly) {
          actions.unshift({
            label: "Eliminar",
            icon: "fas fa-times-circle text-red pr-1",
            visible: !self.isReadOnly,
            click: () => this.deleteStudent(student)
          });
        }

        return actions;
      };
    },
    student() {
      return this.value.student;
    },
    showList() {
      return this.value.studentList.length > 0;
    },
    isDisabled() {
      return !this.value.student;
    },
    showBoxItemBorderBottom() {
      return this.value.studentList.length > 1;
    }
  }
};
</script>

<style scoped lang="scss">
@import "@/assets/scss/variables/_colors.scss";

.box-container {
  border: 5px solid #f2f2f2;
  border-radius: 5px;
}
.box-title {
  font: Bold 1.125rem Lato;
}
.border-divider:after {
  content: "";
  position: absolute;
  top: 50px;
  right: 0;
  height: 50px;
  border-right: 1px solid #e7ebe9;
}
.box-result-empty {
  width: 50%;
  text-align: center;
}
.box-result-field-label {
  color: #727272;
}
.box-result-field-value {
  font-weight: bold;
  /* overflow-wrap: break-word; */
}
.box-divider {
  background-color: #f2f2f2;
}
.box-divider-group:before {
  content: "";
  position: absolute;
  top: 50%;
  right: 0;
  width: 100%;
  border-bottom: 1.5px solid #b5c3bc;
}
.box-item-border-bottom:not(:last-child) {
  border-bottom: 5px solid #f2f2f2;
}
::v-deep .balloon-container {
  color: #fff !important;
  background-color: #b5c3bc !important;
}
.delete-btn {
  margin-right: 15px;
}
::v-deep .balloon-container.dark-gray-bg {
  background-color: #3f5b60 !important;
}
.callout-expanded-container {
  background-color: #fff;
  border: 5px solid #f2f2f2;
  border-radius: 5px;
  padding: 15px 30px;
}
.callout-expanded-item {
  background-color: #f7f7f7;
}
.callout-expanded-item:not(:first-child) {
  margin-top: 10px;
}
.download-icon-btn {
  color: #2db782;
  border: 1px solid #2db782;
  border-radius: 5px;
  background-color: transparent;
}
.outline-success {
  color: #2db782;
  background-color: #ffffff;
  border-color: #2db782;
}
.outline-success:hover {
  background-color: #2db782;
  color: #ffffff;
}
@media (max-width: 765px) {
  ::v-deep .full-width-btn {
    width: 100%;
    margin-top: 15px;
  }
  ::v-deep #action-btn {
    width: 50%;
  }
  ::v-deep .delete-btn {
    margin-right: 0;
  }
  .box-result-empty {
    width: 100%;
  }
  .border-divider:after {
    content: "";
    position: absolute;
    top: 93px;
    right: 15px;
    width: 90%;
    height: 0;
    border-right: none;
    border-bottom: 1px solid #e7ebe9;
  }
  ::v-deep .delete-student-btn {
    width: 100%;
  }
}
::v-deep .custom-ac-btn .ac-btn {
  white-space: unset;
}

::v-deep .balloon-container.green-light {
  background-color: $green_light !important;
  color: black !important;
}
.divider-horizontal {
  border-right: 1px solid #e2e2e2;
}

.divider-vertical {
  margin-bottom: 10px;
  padding-bottom: 10px;
  border-bottom: 1px solid #e2e2e2;
}
</style>
